import(/* webpackMode: "eager" */ "/home/ubuntu/routerbench_new/apps/ui/src/app/global-error.tsx");
